import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './Auth/Dashboard';
import BrandSignIn from './BrandSignIn';
import ForgotPassword from './ForgotPassword';
import BrandOnboarding from './Auth/BrandOnboarding';
import PrivateRoute from './Context/PrivateRoute';
import { AuthProvider } from './Context/AuthContext';
import { NotificationProvider } from './Context/NotificationContext';
import { ChatProvider } from './Chat/ChatContext';
import RequireOnboarding from './Context/RequireOnboarding';
import CookieConsent from "react-cookie-consent";
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <AuthProvider>
        <NotificationProvider>
          <ChatProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/signin" element={<BrandSignIn />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/onboarding" element={<BrandOnboarding />} />
              
              {/* Brand Dashboard Routes */}
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <RequireOnboarding>
                      <Dashboard />
                    </RequireOnboarding>
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <RequireOnboarding>
                      <Dashboard />
                    </RequireOnboarding>
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard/*"
                element={
                  <PrivateRoute>
                    <RequireOnboarding>
                      <Dashboard />
                    </RequireOnboarding>
                  </PrivateRoute>
                }
              />
              
              {/* Temporarily comment out redirect to main site for testing */}
              {/* <Route path="*" element={<RedirectToMain />} /> */}
            </Routes>
          </ChatProvider>
        </NotificationProvider>
      </AuthProvider>
      
      {/* Toast Notifications */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#1a202c',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            padding: '16px 20px',
            fontSize: '14px',
            fontWeight: '500',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      
      {/* Cookie Consent Banner */}
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        cookieName="ugc3_cookie_consent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={365}
      >
        This website uses cookies to enhance the user experience.{" "}
        <span style={{ fontSize: "10px" }}>This bit of text is smaller :O</span>
      </CookieConsent>
    </Router>
  );
}

// Component to redirect to main site
const RedirectToMain = () => {
  React.useEffect(() => {
    window.location.href = 'https://ugc3.co.uk';
  }, []);
  
  return <div>Redirecting to main site...</div>;
};

export default App;
